import axios from 'axios'
import { AccountConversion, ConsumerApplication } from '@/store/consumer-application/types';

const postConsumer = (consumerApplication: ConsumerApplication): Promise<any> => {
    const postConsumerApplicationUrl = '/api/kcc/application/submit';
    return axios.post(postConsumerApplicationUrl, consumerApplication);

}

const getApplicationStatus = (reservationCode: string): Promise<any> => {
    return axios.get(`/api/kcc/application/status/${reservationCode}`);
}


const postAccountConversion = (accountConversion: AccountConversion): Promise<any> => {
    const url = '/api/kcc/application/consent';
    return axios.post(url, accountConversion);
}

export {
    postConsumer, getApplicationStatus, postAccountConversion,
}